module.exports = "data:application/octet-stream;base64,LnR3aXR0ZXIgaW1newoJd2lkdGg6IDEwMCU7Cn0="


//////////////////
// WEBPACK FOOTER
// ./src/Components/react.SocialContainer/react.twitter/style.scss
// module id = 401
// module chunks = 0